export default [
  '#FFF',
  'rgb(247, 182, 210)',
  'rgb(158, 218, 229)',
  'rgb(152, 223, 138)',
  'rgb(199, 199, 199)',
  'rgb(255, 187, 120)',
  'rgb(196, 156, 148)',
  'rgb(197, 176, 213)',
  'rgb(174, 199, 232)',
  'rgb(219, 219, 141)',
  'rgb(255, 152, 150)',
  'rgb(188, 189, 34)',
  'rgb(23, 190, 207)',
  'rgb(225, 127, 14)',
  'rgb(227, 119, 194)',
  'rgb(148, 103, 189)',
  'rgb(44, 160, 44)',
  'rgb(214, 39, 40)',
  'rgb(127, 127, 127)',
  'rgb(31, 119, 180)',
  'rgb(140, 86, 75)',
]



// WEBPACK FOOTER //
// ./src/components/RangeEditor/paletteValue.js